<template>
  <div>
    <div
      :ref="domRef"
      :class="{
        'drop-table-menu': true,
        'drop-table-menu-full-screen': compoundData.fullScreen,
      }"
    >
      <div class="drop-table-menu-header">
        <span class="drop-table-menu-title">选择要展示的表头项</span>
        <el-icon @click="toggleFullScreen" class="drop-table-menu-right-icon">
          <FullScreen />
        </el-icon>
      </div>
      <ElInput
        class="drop-table-filter-header-input"
        v-model="compoundData.filterHeaderText"
        :disabled="false"
        placeholder="请输入筛选项"
      />
      <div class="drop-table-menu-check-wrap">
        <ElCheckbox
          v-model="checkAll"
          :disabled="false"
          :style="{
            display: 'block',
            margin: '0',
            padding: '5px 5px 0px',
            whiteSpace: 'nowrap',
          }"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          全选
        </ElCheckbox>
        <div class="main">
          <div
            class="item"
            v-for="headerItem in filterHeaders"
            :key="headerItem.label"
            draggable="true"
            @dragstart="!headerItem.notSort && dragstart(headerItem)"
            @dragenter="!headerItem.notSort && dragenter(headerItem)"
            @dragend="!headerItem.notSort && dragend(headerItem)"
          >
            <el-icon
              v-show="!headerItem.notSort"
              :size="18"
              v-if="checkSelected(headerItem.prop)"
              @click.stop="cancelSelected(headerItem)"
              color="var(--el-color-primary)"
              style="vertical-align: middle"
            >
              <CircleCheckFilled />
            </el-icon>
            <div
              v-show="!headerItem.notSort"
              v-else
              @click.stop="sureSelected(headerItem)"
              class="circel-radio"
            ></div>
            <div class="checked-text" v-show="!headerItem.notSort">
              {{ headerItem.label }}
            </div>
          </div>
        </div>
        <!-- <ElCheckboxGroup
          v-model="compoundData.checkedHeaders"
          @change="handleCheckedHeadersChange"
        >
          <ElCheckbox
            v-for="header in headers"
            :key="header.prop"
            :label="header.prop"
            :style="{
              display: 'block',
              margin: '0',
              padding: '5px',
            }"
          >
            <div>{{ header.label }}</div>
          </ElCheckbox>
        </ElCheckboxGroup> -->
      </div>
      <el-button-group style="width: 100%">
        <el-button
          :loading="compoundData.loading"
          @click="sureToChange"
          style="width: 33.3%"
          :disabled="false"
          type="primary"
        >
          确定
        </el-button>
        <el-button
          :disabled="false"
          style="width: 33.3%"
          @click="() => menuHideFn()"
        >
          取消
        </el-button>
        <el-button :disabled="false" style="width: 33.3%" @click="resetData">
          重置
        </el-button>
      </el-button-group>
    </div>
  </div>
</template>
<script lang="ts">
import type { UnwrapNestedRefs } from "vue";
import { defineComponent, reactive, ref, onMounted, nextTick, computed } from "vue";
import type { Ref, ComponentPublicInstance, ComputedRef } from "vue";
import type { DataTableColumnType, DataTableType, HeaderMenuCompoundDataType } from "./types";
import type { FetchApiInterface } from "../../commonMix/loadData/types";

import { CircleCheckFilled, FullScreen } from "@element-plus/icons-vue";
import $ from "jquery";
import { ElCheckbox, ElCheckboxGroup, ElIcon } from "element-plus";
import findIndex from "lodash-es/findIndex";
import { find, cloneDeep, sortBy } from "lodash-es";
export default defineComponent({
  components: {
    ElCheckbox,
    // ElCheckboxGroup,
    FullScreen,
    ElIcon,
    CircleCheckFilled,
  },
  props: {
    getTableObj: {
      // 返回table实例
      type: Function,
      default: (obj: ComponentPublicInstance<any, DataTableType> | null) => {
        obj;
      },
    },
  },
  setup(props: any): any {
    const clickVal = ref<DataTableColumnType>();
    const moveVal = ref<DataTableColumnType>();
    const endVal = ref<DataTableColumnType>();
    const dragstart = (item: DataTableColumnType): void => {
      clickVal.value = item;
    };
    const dragenter = (item: DataTableColumnType): void => {
      moveVal.value = item;
    };
    const dragend = (item: DataTableColumnType): void => {
      let nowHeaders: Array<DataTableColumnType> = compoundData.headers;
      endVal.value = item;
      let index = nowHeaders.indexOf(item); //移动元素的当前位置
      let moveObj: DataTableColumnType = moveVal.value ? moveVal.value : {};
      let addIndex = nowHeaders.indexOf(moveObj); //要移动后的位置
      nowHeaders.splice(index, 1);
      nowHeaders.splice(addIndex, 0, item);
    };
    let refMenuWrap: HTMLElement | any;
    const domRef = (el: HTMLElement | any): void => {
      refMenuWrap = el;
    };

    const menuVisible: Ref<boolean> = ref(false);
    const checkAll: Ref<boolean> = ref(false);
    const isIndeterminate: Ref<boolean> = ref(true);

    let compoundData: UnwrapNestedRefs<HeaderMenuCompoundDataType> = reactive({
      checkedHeaders: [],
      fullScreen: false,
      loading: false,
      filterHeaderText: "",
      headers: getHeaders(),
    });

    function getHeaders(): Array<DataTableColumnType> {
      const tableObj: DataTableType = props.getTableObj();
      let res: Array<DataTableColumnType> = [];
      if (tableObj as DataTableType) {
        res = tableObj.compoundData.tableHeadersConfigs;
      }
      return sortBy(cloneDeep(res), (o: any, i: number) =>
        typeof o.sortColumnIndex == "number" ? o.sortColumnIndex : i
      );
    }

    let filterHeaders: ComputedRef<Array<DataTableColumnType>> = computed(
      () => {
        let filterRes: Array<DataTableColumnType> = [];
        if (compoundData.filterHeaderText) {
          compoundData.headers.map((o: DataTableColumnType) => {
            if (o.label.indexOf(compoundData.filterHeaderText) >= 0) {
              filterRes.push(o);
            }
          });
        } else {
          filterRes = compoundData.headers;
        }
        return filterRes;
      }
    );

    /**
     * 扁平化表头数据
     * @param  {Array} tableHeader 表头配置或者子级配置
     */
    function flatHeaders(
      tableHeader: Array<DataTableColumnType>
    ): Array<DataTableColumnType> {
      let res: Array<DataTableColumnType> = [];
      tableHeader &&
        tableHeader.map((item: DataTableColumnType) => {
          res.push(item);
        });
      return res;
    }
    /**
     * 设置选中的表头
     */
    function setCheckedHeaders(): Array<string> {
      const tableObj: DataTableType = props.getTableObj();
      let resArr: Array<string> = [];
      if (tableObj) {
        resArr = tableObj.compoundData.showHeadersState;
      }
      return cloneDeep(resArr);
    }
    /**
     * 右键点击
     *  @param  {Event} MouseEvent 右键事件
     */

    let init = false;
    function rightClick(mouseEvent: MouseEvent): void {
      compoundData.headers = getHeaders();

      compoundData.checkedHeaders = setCheckedHeaders();

      handleCheckedHeadersChange(compoundData.checkedHeaders);
      // 鼠标右击触发事件
      menuVisible.value = false;
      menuVisible.value = true;

      const menu = refMenuWrap;
      document.addEventListener("click", hidenMenu);
      menu.style.display = "block";
      setTimeout(() => {
        menu.style.left = mouseEvent.pageX - 0 + "px";
        menu.style.top =
          (refMenuWrap.clientHeight + mouseEvent.pageY > window.innerHeight
            ? window.innerHeight - refMenuWrap.clientHeight
            : mouseEvent.pageY) -
          0 +
          "px";
      }, 500);
    }

    function menuHideFn() {
      if(refMenuWrap&&refMenuWrap.style) refMenuWrap.style.left = "-3000px";
      menuVisible.value = false;
      compoundData.fullScreen=false;
    }
    /**
     * 点击事件隐藏
     *  @param  {Event} e 点击事件
     */
    function hidenMenu(e: MouseEvent): void {
      if (
        e.target != null &&
        !$(e.target).parents().filter(refMenuWrap).length
      ) {
        menuHideFn();
        document.removeEventListener("click", hidenMenu);
      }
    }
    /**
     * 当触发全选表头
     *  @param  {Object} val 点击事件
     */
    function handleCheckAllChange(val: string): void {
      compoundData.checkedHeaders = val
        ? compoundData.headers.map((o) => o.prop)
        : [];
      isIndeterminate.value = false;
      handleCheckedHeadersChange(compoundData.checkedHeaders);
    }
    /**
     * 切换展示设置回table上的值
     *  @param  {Array} value 设置表头的值
     */
    function handleCheckedHeadersChange(value: Array<string>): void {
      compoundData.checkedHeaders = value;

      const checkedCount = value.length;
      checkAll.value = checkedCount === compoundData.headers.length;
      isIndeterminate.value =
        checkedCount > 0 && checkedCount < compoundData.headers.length;
    }

    /**
     * 当触发全选表头
     *  @param  {Object} val 点击事件
     */
    function checkSelected(val: string): boolean {
      let isSelected = !!compoundData.checkedHeaders.filter((o) => o == val)
        .length;
      return isSelected;
    }

    function cancelSelected(selectItem: DataTableColumnType) {
      let findIdx: number = findIndex(
        compoundData.checkedHeaders,
        (o: string) => {
          return selectItem.prop == o;
        }
      );
      compoundData.checkedHeaders.splice(findIdx, 1);
    }

    function sureSelected(selectItem: DataTableColumnType) {
      let findIdx: number = findIndex(
        compoundData.checkedHeaders,
        (o: string) => {
          return selectItem.prop == o;
        }
      );
      if (findIdx < 0) {
        compoundData.checkedHeaders.push(selectItem.prop);
      }
    }
    async function resetData() {
      const tableObj: ComponentPublicInstance<any, DataTableType> =
        props.getTableObj();

      if (tableObj as ComponentPublicInstance<any, DataTableType>) {
        let tableHeadersConfig = {};
        if (tableObj.$props.storageListKey) {
          // 设置好表头的配置
          if (tableObj.$props.setStorageListFetchApi) {
            compoundData.loading = true;
            try {
              let res: any = await (
                tableObj.$props.setStorageListFetchApi as FetchApiInterface
              )(
                {
                  storageListKey: tableObj.$props.storageListKey,
                  storageConfig: "",
                  id: tableObj.compoundData.storageId,
                },
                {}
              );
              compoundData.loading = false;
              if (!tableObj.compoundData.storageId && res.data) {
                tableObj.compoundData.storageId = res.data;
              }
            } catch (e) {
              compoundData.loading = false;
            }
          } else {
            window.localStorage.setItem(
              "storageListKey_showHeadersState_" +
                tableObj.$props.storageListKey,
              ""
            );
          }
          tableObj.setTableHeadersConfigs(tableObj.$props.tableHeader, {});
          tableObj.compoundData.tableRenderKey = "key_" + new Date().valueOf();
        }
      }
    }
    async function sureToChange() {
      const tableObj: ComponentPublicInstance<any, DataTableType> =
        props.getTableObj();

      if (tableObj as ComponentPublicInstance<any, DataTableType>) {
        let newDataTable: Array<DataTableColumnType> = cloneDeep(
          compoundData.headers
        );
        let newShowHeadersState: Array<string> = cloneDeep(
          compoundData.checkedHeaders
        );
        let newSortShowHeadersState: Array<string> = [];
        newDataTable.map((o: DataTableColumnType): void => {
          if (o.prop && newShowHeadersState.indexOf(o.prop) >= 0) {
            newSortShowHeadersState.push(o.prop);
          }
        });
        let tableHeadersConfig = {};
        if (tableObj.$props.storageListKey) {
          compoundData.headers.map((o: any, i: number) => {
            let findColumnConf = tableHeadersConfig[o.prop] || {};
            tableHeadersConfig[o.prop] = {
              sortColumnIndex: i,
              setColumnWidth: o.setColumnWidth > 0 ? o.setColumnWidth : -1,
              isHiddenColumn: newShowHeadersState.indexOf(o.prop) < 0,
            };
          }); // 设置好表头的配置
          if (tableObj.$props.setStorageListFetchApi) {
            compoundData.loading = true;
            try {
              let res: any = await (
                tableObj.$props.setStorageListFetchApi as FetchApiInterface
              )(
                {
                  storageListKey: tableObj.$props.storageListKey,
                  storageConfig: JSON.stringify({ tableHeadersConfig }),
                  id: tableObj.compoundData.storageId,
                },
                {}
              );
              compoundData.loading = false;
              if (!tableObj.compoundData.storageId && res.data) {
                tableObj.compoundData.storageId = res.data;
              }
            } catch (e) {
              compoundData.loading = false;
            }
          } else {
            window.localStorage.setItem(
              "storageListKey_showHeadersState_" +
                tableObj.$props.storageListKey,
              JSON.stringify({ tableHeadersConfig })
            );
          }

          tableObj.setTableHeadersConfigs(
            tableObj.$props.tableHeader,
            tableHeadersConfig
          );
        }
        tableObj.compoundData.tableHeaderState = newDataTable;
        tableObj.compoundData.showHeadersState = newSortShowHeadersState;
        tableObj.compoundData.tableRenderKey =
          tableObj.compoundData.tableRenderKey + 1;

        tableObj.$props.tableHeader.map((o: any, i: idx) => {
          if (
            tableHeadersConfig[o.prop]&&
            tableHeadersConfig[o.prop].setColumnWidth &&
            tableHeadersConfig[o.prop].setColumnWidth > 0
          ) {
            tableObj.$props.tableHeader[i].width =
              tableHeadersConfig[o.prop].setColumnWidth;
          }
        });
      }
      menuHideFn();
    }
    function toggleFullScreen() {
      compoundData.fullScreen = !compoundData.fullScreen;
    }
    return {
      menuHideFn,
      sureToChange,
      dragstart,
      dragenter,
      dragend,
      filterHeaders,
      menuVisible,
      checkAll,
      isIndeterminate,
      compoundData,
      resetData,
      domRef,
      handleCheckAllChange,
      handleCheckedHeadersChange,
      rightClick,
      checkSelected,
      cancelSelected,
      sureSelected,
      toggleFullScreen,
    };
  },
});
</script>
<style lang="scss" scoped>
.main {
  display: flex;
  flex-direction: column;
  .item {
    cursor: pointer;

    text-align: left;
    height: 36px;
    line-height: 36px;
    margin-left: 5px;

    color: #333;
  }
}
.drop-table-filter-header-input {
  margin: 5px;
  max-width: calc(100% - 10px);
}
.drop-table-menu {
  padding: 0;
  position: fixed;
  border: 1px solid #eee;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  margin: 0;
  z-index: 120;
  left: -3000px;
  &-full-screen {
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    z-index: 10000;
    .main {
      flex-direction: row !important;
      flex-wrap: wrap;
      .item {
        min-width: 200px;
      }
    }
    .drop-table-menu-check-wrap {
      flex: 1;
      min-height: 100px;
      max-height: inherit;
    }
    .drop-table-menu-right-icon {
      color: coral;
    }
  }
  &-right-icon {
    cursor: pointer;
  }
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 10px;
    border-bottom: 1px solid #eee;
  }
  &-check-wrap {
    padding: 10px;
    max-height: 250px;
    overflow: auto;
  }
  &-list {
    font-size: 14px;
    padding: 0;
    margin: 0;
    list-style: none;

    &-item:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
    &-item {
      font-size: 15px;
      list-style: none;
      padding: 5px 10px;
      margin: 0;
    }
  }
}
.circel-radio {
  width: 13px;
  height: 13px;
  border: 2px solid #eee;
  border-radius: 100%;
  display: inline-block;
  vertical-align: middle;
}
.checked-text {
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
}
</style>
